exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-module-automation-panel-modal .panel-empty[data-v-26933524]{padding-top:1.5rem;padding-bottom:1rem;font-size:.875rem;line-height:1rem;text-align:center;color:var(--fts-default)}", ""]);

// exports
